import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The custom shadows from index.css, so cn() lets a later shadow-* override them.
const twMerge = extendTailwindMerge({
  extend: { classGroups: { shadow: [{ shadow: ["control", "card", "popover"] }] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDeviceModel(model: string): string {
  return model.replace(/┼/g, ", ");
}

/** Short date for listing tables: "Feb 6, 2025" */
export function formatDate(isoString: string): string {
  return new Date(isoString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

/** Date + time for detail pages: "Feb 6, 2025, 03:45 PM" */
export function formatDateTime(isoString: string): string {
  return new Date(isoString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Full date + time for tooltips: "February 6, 2025, 3:45:30 PM" */
export function formatFullDateTime(isoString: string): string {
  return new Date(isoString).toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
  });
}
